import { Outlet } from "react-router-dom";
import { useRef } from "react";
import { useResizeDetector } from "react-resize-detector";

export const RootLayout = () => {
  const { height } = useResizeDetector();
  const containerRef = useRef<HTMLDivElement>(null);

  return (
      <div className="min-h-screen bg-center bg-no-repeat bg-cover overflow-y-auto flex justify-center">
          <div
              ref={containerRef}
              className="z-10 w-[80%]"
          >
              <Outlet />
          </div>
      </div>
  );
};
